import React from 'react'

import { CookiePolicyPage } from './cookie-policy-page.component'
import { cookiePolicyUSContent } from './cookie-policy-us.constants'

export const CookiePolicyUSPage: React.FC = () => {
  return (
    <CookiePolicyPage
      content={cookiePolicyUSContent}
      showOneTrustList={false}
    />
  )
}
